export default "__VITE_ASSET__CAIJ2DCm__"